module.exports = __webpack_public_path__ + "img/msg.92642841.png";